import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './CardIndex.module.scss';
import isEmpty from '../../utils/isEmpty';
import Image from '../Image';
import RentalTag from '../RentalTag';

const CardIndex = ({ cards, type }) => {
    const cardIndexClass = classNames(styles['CardIndex'], {
        [styles['CardIndex--Full']]: type === 'fullwidth',
        [styles['CardIndex--Half']]: type === 'halves',
    });
    return (
        !isEmpty(cards) &&
        cards.map(({ ...cards }, idx) => {
            return (
                <Card {...cards} key={idx} cardIndexClass={cardIndexClass} />
            );
        })
    );
};

const Card = ({
    title,
    href,
    text,
    image,
    cardIndexClass,
    type,
    rentalTag,
    rentalAreaName,
}) => {
    const Tag = isEmpty(href) ? 'div' : 'a';
    let props = {};

    if (href) {
        props.href = href;
    }

    return (
        <Tag {...props} className={cardIndexClass}>
            <div className={styles['CardIndex__Image']}>
                <Image maxImageWidth={1020} {...image} altText={''} />
                {type === 'rental' && rentalTag && (
                    <RentalTag
                        rentalTag={rentalTag}
                        rentalAreaName={rentalAreaName}
                    />
                )}
            </div>
            <div className={styles['CardIndex__Inner']}>
                <h2 className={styles['CardIndex__Title']}>{title}</h2>
                <p className={styles['CardIndex__Text']}>{text}</p>
            </div>
        </Tag>
    );
};

CardIndex.propTypes = {
    cards: PropTypes.array,
    type: PropTypes.string,
};

CardIndex.defaultProps = {
    cards: [],
    type: '',
};

Card.propTypes = {
    title: PropTypes.string,
    href: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.object,
    cardIndexClass: PropTypes.string,
    type: PropTypes.string,
    rentalTag: PropTypes.string,
    rentalAreaName: PropTypes.string,
};

Card.defaultProps = {
    title: '',
    href: '',
    text: '',
    image: {},
    cardIndexClass: '',
    type: '',
    rentalTag: '',
    rentalAreaName: '',
};

export default CardIndex;
